import { Components, Theme } from '@mui/material';

export const radioStyles: Components<Theme>['MuiRadio'] = {
  styleOverrides: {
    root: {
      padding: '8px',
      '& .MuiSvgIcon-root': {
        width: '25px',
        height: '25px'
      }
    }
  }
};
